/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import { NotificationActions } from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

 export const fetchNotificationsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.NOTIFICATIONS_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, NotificationActions.receiveNotices))
);

export const clearNotificationsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.NOTIFICATIONS_CLEAR && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, NotificationActions.clearedNotices))
);
